var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    stroke: "none",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9999L10.6422 15.8211C10.7734 15.8866 10.839 15.9194 10.9078 15.9324C10.9687 15.9438 11.0313 15.9438 11.0922 15.9324C11.161 15.9194 11.2266 15.8866 11.3578 15.8211L21 10.9999M1 15.9999L10.6422 20.8211C10.7734 20.8866 10.839 20.9194 10.9078 20.9324C10.9687 20.9438 11.0313 20.9438 11.0922 20.9324C11.161 20.9194 11.2266 20.8866 11.3578 20.8211L21 15.9999M1 5.99994L10.6422 1.17883C10.7734 1.11324 10.839 1.08044 10.9078 1.06753C10.9687 1.0561 11.0313 1.0561 11.0922 1.06753C11.161 1.08044 11.2266 1.11324 11.3578 1.17883L21 5.99994L11.3578 10.8211C11.2266 10.8866 11.161 10.9194 11.0922 10.9324C11.0313 10.9438 10.9687 10.9438 10.9078 10.9324C10.839 10.9194 10.7734 10.8866 10.6422 10.8211L1 5.99994Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.0ae1699dd56cf929bba8ccdecb09091d.svg";
export { ForwardRef as ReactComponent };